import {addEvent} from '../add-event'

export function failToSignInEvent(errorType: 'inactiveUser' | 'unknownUser'): boolean {
    return addEvent('loginPageFailToSignIn', {errorType})
}
